import { postFormData } from "../methods";
function postUploadTransactions(payload, headers = {}) {
  const formData = new FormData();
  formData.append("file", payload.file);
  return postFormData({
    url: "/backend/portfolio/portfolio-transaction/csv-transform",
    payload: formData,
    headers
  });
}
export {
  postUploadTransactions as default
};
